interface PersonalizationState {
  color: string;
  font: number;
  invalidText: string;
  isInitialTextEdit: boolean;
  text: string;
}

const initialPersonalizationState: PersonalizationState = {
  color: '',
  font: 0,
  invalidText: '',
  isInitialTextEdit: true,
  text: '',
};

export type { PersonalizationState };
export default initialPersonalizationState;
